const iconViewBox: { [k: string]: string } = {};

const renderIcon = (icon: string) => {
  switch (icon) {
    case "back":
      return (
        <path
          d="M7.6 14L18.1 3.5a1 1 0 0 0-.007-1.407L16.707.707a1.003 1.003 0 0 0-1.415.001L0 16l15.292 15.292c.391.391 1.03.387 1.415.001l1.386-1.386c.39-.39.384-1.03.006-1.408L7.6 18h23.398A1 1 0 0 0 32 16.99v-1.98c0-.558-.444-1.01-1.002-1.01H7.6z"
          fill="currentColor"
          fillRule="evenodd"
        />
      );

    case "search":
      return (
        <g
          transform="translate(1 1)"
          stroke="currentColor"
          strokeWidth="2"
          fill="none"
          fillRule="evenodd"
          strokeLinecap="square"
        >
          <path d="M29 29l-7.733-7.733" />
          <circle cx="12.429" cy="12.429" r="12.429" />
        </g>
      );

    case "close":
      return (
        <g
          stroke="currentColor"
          strokeWidth="5"
          fill="none"
          fillRule="evenodd"
          strokeLinecap="square"
        >
          <path d="M28 4L4 28M28 28L4 4" />
        </g>
      );

    case "info":
      return (
        <g transform="translate(1 1)" fill="none" fillRule="evenodd">
          <circle
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="square"
            cx="15"
            cy="15"
            r="15"
          />
          <path
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="square"
            d="M12.273 13.636H15v8.182M12.273 21.818h5.454"
          />
          <circle
            fill="currentColor"
            fillRule="nonzero"
            cx="15"
            cy="8.182"
            r="1.364"
          />
        </g>
      );

    case "delete":
      return (
        <path
          d="M26.82 9.332H4.323C3.593 9.332 3 8.735 3 8V6.665c0-.736.592-1.333 1.323-1.333h3.97c0-1.954.407-3.095 1.313-4.008C10.512.41 11.642 0 13.58 0h3.982c1.94 0 3.069.41 3.974 1.324.906.913 1.314 2.054 1.314 4.008h3.97c.73 0 1.323.597 1.323 1.333V8c0 .736-.593 1.333-1.323 1.333zm-7.273-6.004a2.529 2.529 0 0 0-1.988-.662h-3.976a2.529 2.529 0 0 0-1.987.662 2.578 2.578 0 0 0-.656 2.004h9.263a2.578 2.578 0 0 0-.656-2.004zm5.943 7.338a.66.66 0 0 1 .483.21.67.67 0 0 1 .18.498l-1.168 18.75A1.996 1.996 0 0 1 22.997 32H8.144a1.996 1.996 0 0 1-1.988-1.875L4.988 11.374a.67.67 0 0 1 .18-.499.66.66 0 0 1 .483-.21H25.49z"
          fill="currentColor"
          fillRule="nonzero"
        />
      );

    case "edit":
      return (
        <path
          d="M19.898 5.34l6.51 6.542L9.93 28.44l-6.506-6.542L19.898 5.34zm11.45-1.577L28.443.846a2.87 2.87 0 0 0-4.069 0l-2.78 2.794 6.509 6.541 3.243-3.26c.87-.874.87-2.284 0-3.158zM.017 31.093a.742.742 0 0 0 .896.885l7.254-1.767-6.506-6.541-1.644 7.423z"
          fill="currentColor"
          fillRule="nonzero"
        />
      );

    case "note":
      return (
        <g fill="currentColor" fillRule="evenodd">
          <path d="M21.946 6.667V5.333c0-.736-.619-1.333-1.38-1.333-.763 0-1.381.597-1.381 1.333v1.334h2.76z" />
          <path d="M17.804 31.117v-5.784c0-.368 1-1.333 1.38-1.333h7.452l-8.832 7.117zM7.451 9.333a.679.679 0 0 1-.69-.666c0-.37.31-.667.69-.667h13.804c.381 0 .69.297.69.667 0 .368-.309.666-.69.666H7.451zm8.283 4H7.45a.679.679 0 0 1-.69-.666c0-.37.31-.667.69-.667h8.283c.38 0 .69.297.69.667 0 .368-.31.666-.69.666zm0 4H7.45a.679.679 0 0 1-.69-.666c0-.37.31-.667.69-.667h8.283c.38 0 .69.297.69.667 0 .368-.31.666-.69.666zM26.777 0H4.69A.679.679 0 0 0 4 .667v30.666c0 .368.309.667.69.667h13.804a.704.704 0 0 0 .441-.155l8.283-6.666a.654.654 0 0 0 .248-.512v-24a.679.679 0 0 0-.69-.667z" />
        </g>
      );

    case "addNote":
      return (
        <g fill="currentColor">
          <path
            d="M2.83008 7.03516C3.32617 7.03516 3.79102 7.13086 4.22461 7.32227C4.66211 7.50977 5.04688 7.76953 5.37891 8.10156C5.71094 8.43359 5.9707 8.81836 6.1582 9.25586C6.34961 9.68945 6.44531 10.1543 6.44531 10.6504C6.44531 10.9785 6.40039 11.2949 6.31055 11.5996C6.22461 11.9043 6.10156 12.1895 5.94141 12.4551H10.4883C11.0742 12.4551 11.5137 12.3066 11.8066 12.0098C12.1035 11.7129 12.252 11.2695 12.252 10.6797V5.68164H8.17383C7.47852 5.68164 7.13086 5.33594 7.13086 4.64453V0.513672H4.59375C4.01172 0.513672 3.57227 0.664062 3.27539 0.964844C2.97852 1.26172 2.83008 1.70508 2.83008 2.29492V7.03516ZM8.22656 4.90234H12.1875C12.1719 4.77734 12.123 4.65625 12.041 4.53906C11.959 4.41797 11.8477 4.28711 11.707 4.14648L8.66602 1.05859C8.5332 0.921875 8.4043 0.810547 8.2793 0.724609C8.1582 0.638672 8.03711 0.587891 7.91602 0.572266V4.5918C7.91602 4.79883 8.01953 4.90234 8.22656 4.90234ZM2.83594 13.4863C3.21875 13.4863 3.58008 13.4121 3.91992 13.2637C4.26367 13.1152 4.56641 12.9102 4.82812 12.6484C5.08984 12.3867 5.29492 12.084 5.44336 11.7402C5.5957 11.4004 5.67188 11.0371 5.67188 10.6504C5.67188 10.1309 5.54297 9.65625 5.28516 9.22656C5.03125 8.79688 4.6875 8.45508 4.25391 8.20117C3.82422 7.94336 3.35156 7.81445 2.83594 7.81445C2.31641 7.81445 1.84375 7.94336 1.41797 8.20117C0.988281 8.45508 0.644531 8.79688 0.386719 9.22656C0.128906 9.65625 0 10.1309 0 10.6504C0 11.0371 0.0742188 11.4023 0.222656 11.7461C0.371094 12.0898 0.576172 12.3926 0.837891 12.6543C1.0957 12.916 1.39648 13.1191 1.74023 13.2637C2.08398 13.4121 2.44922 13.4863 2.83594 13.4863ZM2.83594 12.4375C2.72656 12.4375 2.63867 12.4043 2.57227 12.3379C2.50586 12.2715 2.47266 12.1855 2.47266 12.0801V11.0078H1.40625C1.30078 11.0078 1.21484 10.9746 1.14844 10.9082C1.08203 10.8457 1.04883 10.7598 1.04883 10.6504C1.04883 10.541 1.08203 10.4551 1.14844 10.3926C1.21484 10.3262 1.30078 10.293 1.40625 10.293H2.47266V9.22656C2.47266 9.11719 2.50586 9.0293 2.57227 8.96289C2.63867 8.89648 2.72656 8.86328 2.83594 8.86328C2.94141 8.86328 3.02734 8.89648 3.09375 8.96289C3.16016 9.0293 3.19336 9.11719 3.19336 9.22656V10.293H4.26562C4.37109 10.293 4.45703 10.3262 4.52344 10.3926C4.58984 10.4551 4.62305 10.541 4.62305 10.6504C4.62305 10.7598 4.58984 10.8457 4.52344 10.9082C4.45703 10.9746 4.37109 11.0078 4.26562 11.0078H3.19336V12.0801C3.19336 12.1855 3.16016 12.2715 3.09375 12.3379C3.02734 12.4043 2.94141 12.4375 2.83594 12.4375Z"
            fill="currentColor"
          />
        </g>
      );

    case "arrowDown":
      return (
        <path
          stroke="currentColor"
          strokeWidth="4.655"
          d="M30.364 9.636L15.938 22.364 2.364 9.636"
          fill="none"
          fillRule="evenodd"
        />
      );

    case "mapPin":
      return (
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 7.88104C0 3.53543 3.53543 0 7.88108 0C12.2267 0 15.7621 3.53543 15.7622 7.88104C15.7622 13.2741 8.70936 21.1914 8.40909 21.5258C8.12755 21.8394 7.63512 21.8399 7.35307 21.5258C7.05279 21.1914 0 13.2741 0 7.88104ZM3.91595 7.88104C3.91595 10.0674 5.69468 11.8462 7.88108 11.8462C10.0674 11.8462 11.8462 10.0675 11.8462 7.88108C11.8462 5.69468 10.0674 3.91591 7.88108 3.91591C5.69472 3.91591 3.91595 5.69463 3.91595 7.88104Z"
          fill="currentColor"
        />
      );

    case "cancelCircle":
      return (
        <path
          d="M6.64453 13.6411C7.55143 13.6411 8.40592 13.4657 9.20801 13.1147C10.0101 12.7684 10.7165 12.2899 11.3271 11.6792C11.9378 11.0685 12.4163 10.3644 12.7627 9.56689C13.109 8.76481 13.2822 7.90804 13.2822 6.99658C13.2822 6.08968 13.1068 5.23519 12.7559 4.43311C12.4095 3.63102 11.931 2.92464 11.3203 2.31396C10.7096 1.70329 10.0033 1.22477 9.20117 0.878418C8.39909 0.532064 7.5446 0.358887 6.6377 0.358887C5.73079 0.358887 4.8763 0.532064 4.07422 0.878418C3.27669 1.22477 2.57031 1.70329 1.95508 2.31396C1.3444 2.92464 0.865885 3.63102 0.519531 4.43311C0.173177 5.23519 0 6.08968 0 6.99658C0 7.90804 0.173177 8.76481 0.519531 9.56689C0.870443 10.3644 1.35124 11.0685 1.96191 11.6792C2.57259 12.2899 3.27669 12.7684 4.07422 13.1147C4.8763 13.4657 5.73307 13.6411 6.64453 13.6411ZM4.67578 10.0659C4.52083 10.0659 4.39095 10.0181 4.28613 9.92236C4.18131 9.8221 4.12891 9.69906 4.12891 9.55322C4.12891 9.42106 4.17676 9.29118 4.27246 9.16357L5.90625 6.91455L4.36133 4.78174C4.2474 4.64046 4.19043 4.49691 4.19043 4.35107C4.19043 4.20068 4.2474 4.07536 4.36133 3.9751C4.47526 3.87028 4.6097 3.81787 4.76465 3.81787C4.8877 3.81787 4.99023 3.84294 5.07227 3.89307C5.1543 3.9432 5.23633 4.02979 5.31836 4.15283L6.67871 6.12842H6.71973L8.0459 4.15967C8.12793 4.03662 8.20768 3.95003 8.28516 3.8999C8.36719 3.84521 8.46745 3.81787 8.58594 3.81787C8.74089 3.81787 8.87077 3.868 8.97559 3.96826C9.08496 4.06396 9.13965 4.18701 9.13965 4.3374C9.13965 4.46956 9.08952 4.60173 8.98926 4.73389L7.3623 6.94189L8.97559 9.13623C9.07585 9.26383 9.12598 9.396 9.12598 9.53271C9.12598 9.68766 9.07129 9.81527 8.96191 9.91553C8.8571 10.0158 8.72038 10.0659 8.55176 10.0659C8.43783 10.0659 8.33984 10.0409 8.25781 9.99072C8.18034 9.93604 8.09375 9.84489 7.99805 9.71729L6.6377 7.74854H6.60352L5.22949 9.71729C5.13379 9.84945 5.0472 9.94059 4.96973 9.99072C4.89225 10.0409 4.79427 10.0659 4.67578 10.0659Z"
          fill="currentColor"
        />
      );

    default:
      return false;
  }
};

interface Props {
  icon: string;
  className?: string;
  id?: string;
  customViewBox?: string;
  height?: string;
  width?: string;
  color?: string;
}

const Icon = ({
  icon,
  customViewBox,
  className,
  id,
  height,
  width,
  color,
}: Props) => (
  <svg
    viewBox={customViewBox || iconViewBox[icon] || "0 0 32 32"}
    preserveAspectRatio="xMidYMid meet"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    id={id}
    height={height}
    width={width}
    color={color && color}
  >
    {renderIcon(icon)}
  </svg>
);

export default Icon;
